import React from 'react';
import { SignInStep, useSignInStep } from '@talbenmoshe/trip-os-react-model';
import { CodeStep } from './CodeStep.js';
import { EmailStep } from './EmailStep.js';

/**
 * The login site's only screen: the email step or the code step. A finished sign-in keeps the step it happened on
 * (email after Google, code after a code), locked, while the browser leaves. It reads the step alone, so the
 * countdown's ticks re-render only the step that shows it.
 */
export function SignInPage() {
  const step = useSignInStep();

  return step === SignInStep.EMAIL ? <EmailStep /> : <CodeStep />;
}
